<template lang="pug">
  .report

    .option
      span ordernar por
      PRadio(label="nome", v-model="reportOptions.orderBy", option="name")
      PRadio(label="porcentagem", v-model="reportOptions.orderBy", option="percent")

    .option
      span tipo do relatório
      PRadio(label="presença", v-model="reportOptions.reportFormat", option="presence")
      PRadio(label="por ponto batido", v-model="reportOptions.reportFormat", option="timelog")

    .option
      span orientação do PDF
      PRadio(label="retrato", v-model="reportOptions.orientation", option="portrait")
      PRadio(label="paisagem", v-model="reportOptions.orientation", option="landscape")

    .option
      PCheckbox(v-model="reportOptions.displayNotSyncSepareted" :label="`Listar ${$wp('employee')} com dispositivos não sincronizados`")

    .button
      PButton(color="success" size="md" @click="generate('pdf')" :loading="loading.pdf" :disabled="!valid") gerar pdf
      PButton(color="success" size="md" @click="generate('excel')" :loading="loading.excel" :disabled="!valid") gerar excel

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: {pdf: false, excel: false},
      reportOptions: {
        orderBy: 'name',
        reportFormat: 'presence',
        orientation: 'portrait',
        displayNotSyncSepareted: false
      }
    }
  },
  methods: {
    async generate (reportType) {
      this.loading[reportType] = true

      let result

      try {
        result = await this.$API.R12.save({reportType}, {
          entity: this.reportInfo.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          ...this.reportOptions,
          filters: ['all', 'folga', 'absence', 'presence', 'folga_worked', 'vacation', 'leave'],
          typeReport: reportType,
          orderBy: 'name',
          startDate: moment(this.reportInfo.periodData.startDate).format('DD/MM/YYYY'),
          endDate: moment(this.reportInfo.periodData.endDate).format('DD/MM/YYYY')
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading[reportType] = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr;

  .option {
    span {grid-column: 1/3}

    display: grid;
    grid-template-columns: max-content max-content;
    grid-column-gap: 30px;
  }
  .button {
    grid-column: 1/4;
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
